import RoomsEnumBedAndBathroomsType from './BedAndBathroomType';
import RoomsEnumRoomType from './RoomType';

const RoomsEnum = {
  RoomType: RoomsEnumRoomType,
  BedAndBathroomType: RoomsEnumBedAndBathroomsType,
};

export default RoomsEnum;
